import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { CartContext } from "components/cart";
import Product from "./Product";
import Axios from "axios";
import classNames from "lib/classNames";
import API from "../Api";
import { API_GATEWAY } from "aws-exports";

const AddToUnlock = ({ add_to_unlock, add_to_unlock_product_id }) => {
  const cartContext = useContext(CartContext);
  const {
    cart_settings: { theme, font },
    shopify_cart_items,
    Utils,
    get_total,
    shop_url,
    isPreview,
    productNotAddedToCart,
    rechargeSettings,
    hasWriteDiscountsScope
  } = cartContext;
  const {
    borderColor,
    background,
    show_suggestions,
    recommendation_type = "custom_recommendation",
    products_length = 1,
    exclude_tags
  } = add_to_unlock;

  const [upSells, setUpSells] = useState([]);
  const filterUpsells = (value) => {
    return value.filter((product) => {
      const subscriptionObject = rechargeSettings?.products?.find((p) => {
        return Object.keys(p)[0] === product.id.toString();
      });
      const subscription = subscriptionObject && subscriptionObject[product.id];
      if (
        subscription &&
        subscription?.subscription_options?.storefront_purchase_options !==
          "subscription_and_onetime"
      ) {
        return false;
      }
      return true;
    });
  };
  const [allProducts, setAllProducts] = useState([]);
  const add_to_unlock_reward = add_to_unlock[add_to_unlock.reward_type];
  const handleSetAllProducts = (tmpProducts) => {
    // console.log("tmpProducts")
    // console.log(tmpProducts)
    // tmpProducts = tmpProducts.filter(prd => {
    // 	const {inventory_quantity, inventory_policy, inventory_management } = prd.variants[0]
    // 	return (inventory_quantity > 0 || inventory_management !== "shopify" || ( inventory_management === "shopify" && inventory_policy === "continue" ))
    // })

    setAllProducts(tmpProducts);
  };

  // set all possible poducts without the recommandations
  useEffect(() => {
    const tmpProducts = add_to_unlock.products.length
      ? add_to_unlock.products
      : isPreview
      ? Utils.fakePreviewProducts()
      : [];
    if (recommendation_type !== "shopify_recommendation")
      handleSetAllProducts(tmpProducts);
  }, [add_to_unlock.products, show_suggestions, recommendation_type]);

  // handle items change
  useEffect(() => {
    let tmpProducts = allProducts.filter(productNotAddedToCart).slice(0);
    if (show_suggestions && recommendation_type == "shopify_recommendation") {
      tmpProducts = tmpProducts
        .filter((prod) => checkTags(prod, exclude_tags))
        .splice(0, products_length);
    }
    console.log({ hasWriteDiscountsScope });
    if (rechargeSettings && !hasWriteDiscountsScope) {
      tmpProducts = filterUpsells(tmpProducts);
    }
    setUpSells(tmpProducts);
  }, [
    shopify_cart_items,
    allProducts,
    show_suggestions,
    recommendation_type,
    products_length,
    exclude_tags,
    rechargeSettings,
    hasWriteDiscountsScope
  ]);

  useEffect(() => {
    let tmpUpsel = (
      add_to_unlock.products.length
        ? add_to_unlock.products
        : isPreview
        ? Utils.fakePreviewProducts()
        : []
    ).filter(productNotAddedToCart);
    if (rechargeSettings && !hasWriteDiscountsScope) {
      tmpUpsel = filterUpsells(tmpUpsel);
    }
    setUpSells(tmpUpsel);

    if (show_suggestions && recommendation_type == "shopify_recommendation") {
      if (isPreview) {
        API.get(
          `${API_GATEWAY}/public/products?shop=${shop_url}&limit=10`
        ).then(({ data }) => {
          const { products } = data;
          let tmpProducts = parseProducts(products);

          handleSetAllProducts(tmpProducts);
        });

        return;
      }
      const recoEndpoint = `/recommendations/products.json?product_id=${add_to_unlock_product_id}`;
      // const endpoint = 'https://shopquoteworthy.com/recommendations/products.json?product_id=5803024318625'
      // const recoEndpoint = '/recommendations/products.json?product_id=3320752701504'
      const productsEndpoint = "/products.json?limit=20";
      Axios.get(recoEndpoint).then(({ data }) => {
        const { products } = data;
        if (products) {
          if (products.length) {
            // map product and set it setAllProducts
            const tmpProducts = parseProducts(products);
            handleSetAllProducts(tmpProducts);
          } else {
            Axios.get(productsEndpoint).then(({ data: productsData }) => {
              const { products } = productsData;
              const tmpProducts = parseProducts(products);
              handleSetAllProducts(tmpProducts);
            });
          }
        }
      });
    }
  }, [show_suggestions, recommendation_type]);

  const parseProducts = (products) => {
    return products.map((product) => {
      return {
        id: product.id,
        title: product.title,
        handle: product.handle,
        image: product.images.length
          ? product.images[0].src || product.images[0]
          : null,
        options: product.options,
        tags: product.tags,
        variants: product.variants.map((v) => {
          return {
            id: v.id,
            title: v.title,
            price: v.price / 100,
            image: v.featured_image ? v.featured_image.src : null
          };
        })
      };
    });
  };

  const checkTags = (product, tags = []) => {
    if (!tags) return true;
    return tags.every(
      (tag) =>
        !product.tags || (product.tags && product.tags.indexOf(tag) === -1)
    );
  };

  return upSells.length ? (
    <>
      {add_to_unlock.separator.active && (
        <div
          className={classNames("text-center my-3")}
          style={{
            lineHeight: "2px",
            background: Utils.formatColor(font.color, 0.28)
          }}
        >
          <span
            style={{
              background: Utils.formatColor(theme.background)
            }}
            className={classNames("px-2 font-bold")}
          >
            {add_to_unlock.separator.text}
          </span>
        </div>
      )}
      <div
        className={classNames("rounded border mb-2 frequently-container", {
          "mt-5": add_to_unlock.separator.active,
          "mt-1": !add_to_unlock.separator.active
        })}
        style={{ borderColor: Utils.formatColor(borderColor) }}
      >
        <div
          className={classNames(
            "text-center p-2 font-bold rounded-t w-full frequently-header"
          )}
          style={{
            background: Utils.formatColor(background),
            color: Utils.formatColor(add_to_unlock.title.color),
            fontSize: Utils.em(add_to_unlock.title.font_size)
          }}
        >
          {add_to_unlock.title.text}
        </div>
        <div>
          {upSells.map((product) => {
            return (
              <Product
                key={product.id}
                product={product}
                add_to_unlock={add_to_unlock}
              />
            );
          })}
        </div>
      </div>
    </>
  ) : null;
};

// quotebujosandmore.myshopify.com/recommendations/products.json?product_id=36765506109601
// https://shopquoteworthy.com//recommendations/products.json?product_id=36765506109601

//3wizzystore.myshopify.com/recommendations/products.json?product_id=3431364624448

// 3431364624448
// const formateText = (text, rewardType, { type, reward, goal }, formatMoney, get_total) => {
// 	let replacedReward =
// 		rewardType === 'discount' ? (type === 'percentage' ? `${reward}%` : formatMoney(reward * 100)) : '';
// 	let replacedAmount = formatMoney(goal * 100 - get_total('original'));
// 	return text.replace('{{amount}}', replacedAmount).replace('{{reward}}', replacedReward);
// };

https: AddToUnlock.propTypes = {};

export default AddToUnlock;
